const Footer = (props) => {

    return (
        <footer id="footer-container" className="relative text-white h-screen w-full ">
            <div className="h-4/5 w-full flex flex-row ">
                <div className=" flex justify-center w-4/5 py-4">
                    <ul className=" list-none flex flex-col justify-around bg-transparent px-2 py-4 h-full w-1/2 rounded-2xl ">
                        <div className="flex flex-row align-middle justify-center p-2  ">    
                        <li  className="flex align-middle justify-center px-2 text-lg "><a href="#about" className="flex items-center justify-center text-lg text-white hover:text-customyellow focus:text-red-900 " >About</a></li>
                        </div>
                        <div className="flex flex-row align-middle justify-center p-2 ">
        
                        <li className="flex align-middle justify-center px-2 text-lg"><a href="#experience" className="flex items-center justify-center text-lg text-white hover:text-customyellow focus:text-red-900 ">Experience</a></li>
                        </div>
                        <div className="flex flex-row align-middle justify-center p-2 ">
        
                        <li className="flex align-middle justify-center px-2 text-lg"><a href="#builds" className="flex items-center justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Builds</a></li>
                        </div>
                        <div className="flex flex-row align-middle justify-center p-2 ">
        
                        <li className="flex align-middle justify-center px-2 text-lg"><a href="#contact" className="flex items-center justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Contact</a></li>
                        </div>
                        <div className="flex flex-row align-middle justify-center p-2 ">    
                        <li className="flex align-middle justify-center px-2 text-lg"><a href="#resume" className="flex items-center justify-center text-lg text-white hover:text-customyellow focus:text-red-900 "> Resume</a></li>
                        </div>
                    </ul>
                </div>

                <div className="flex flex-col justify-center items-center w-1/5 py-4">
                    <div className="flex flex-col justify-center items-center ">
                    <span>|</span>
                    <a className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 " href="https://www.linkedin.com/in/yanick-ndi-3b01a397/" target="_blank" rel="noopener noreferrer" title="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
                    <span>|</span>
                    <a className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 " href="https://twitter.com/YanickNdi" target="_blank" rel="noopener noreferrer" title="Twitter"><i className="fab fa-twitter"></i></a>
                    <span>|</span>
                    <a className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 " href="https://codepen.io/yanick-web" target="_blank" rel="noopener noreferrer" title="Codepen"><i className="fab fa-codepen"></i></a>
                    <span>|</span>
                    <a className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 " href="https://github.com/Yanick-web" target="_blank" rel="noopener noreferrer" title="Github"><i className="fab fa-github-alt"></i></a>
                    <span>|</span>
                    <a className="flex align-middle justify-center text-lg text-white hover:text-customyellow focus:text-red-900 " href="mailto:pizares@yahoo.fr"  title="Email me"><i className="far fa-envelope"></i></a>
                    <span>|</span>
                    </div>
                </div>
            </div>
            <div id="footer-end" className="h-1/5 w-full flex fle-col justify-center items-center ">
                <p className="text-gray-500"><span>|</span>Designed &amp; and Built by Yanick Ndi. &copy; {props.year }<span>|</span></p>
            </div>
        </footer>
    );
};



export default Footer;